import { render, staticRenderFns } from "./RecordingTableStaff.vue?vue&type=template&id=5162b8f1&scoped=true"
import script from "./RecordingTableStaff.vue?vue&type=script&lang=js"
export * from "./RecordingTableStaff.vue?vue&type=script&lang=js"
import style0 from "./RecordingTableStaff.vue?vue&type=style&index=0&id=5162b8f1&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162b8f1",
  null
  
)

export default component.exports